
const Profile = () => {
    return <h1>Profile page</h1>
}

export default Profile;